A resource identifier for the position.

This identifies the relevant position profile within the position opening.
It can be matched with the position profile `positionUri` field.

- For candidate application profiles from the Optimised Apply use case,
  this is the public web URL of the posted job ad.

- For purchased candidate profiles from the Proactive Sourcing use case,
  this is the object identifier of the relevant unposted position profile.
